import { render, staticRenderFns } from "./FarmCoordinateEditDialog.vue?vue&type=template&id=64cbc020"
import script from "./FarmCoordinateEditDialog.vue?vue&type=script&lang=js"
export * from "./FarmCoordinateEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports